// extracted by mini-css-extract-plugin
module.exports = {"block":"Block_block__36EEP","text":"Block_text__3ENYs","full":"Block_full__3X1w5","img":"Block_img__3SFmf"};